import React from 'react';

export default function NavIcon({ Icon }) {
    return <Icon height="2em" width="2em" />;
}
